var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweetList"},_vm._l((_vm.tweets),function(tweet){return _c('blockquote',{key:tweet.id,staticClass:"twitter-tweet"},[_c('a',{attrs:{"href":("https://twitter.com/" + (tweet.id) + "/status/" + (tweet.status_id))}})])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d630e312","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/TweetList.vue
// module id = null
// module chunks = 